import InputCheckbox from "components/page/user/contract/edit/input/inputCheckbox";
import { BlockBase, HeadlineHeader } from "components/page/user/contract/edit/parts/blockBase";
import { CONTRACT_EDIT_INFO } from "constants/contractEditPageInfo";
import React from "react";

/** 清算の対象となる土地 */
export default class Block2 extends BlockBase {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            headlineId: "030202",
        };
    }

    handleTo0101 = e => {
        e.preventDefault();
        // リロードをかける
        this.props.pageSwitch(CONTRACT_EDIT_INFO.PAGE_0101.id);
    }

    render() {
        const { hideBlockClass, params } = this.renderCommon();

        // 非表示判定の場合、null(react的な表示なし)を返す
        if (this.dohide(this.props.pageState.hidingHeadline)) { return null; }

        return (
            <div className={`dataList dataList__accordion ${hideBlockClass}`}>
                <div className="dataList-header">
                    <div className="dataList-header-title">清算の対象となる土地</div>
                    <HeadlineHeader onClick={this.handleHide} hide={this.state.hide} />
                </div>
                <div className="dataList-body">
                    <table className="dataTable">
                        <tbody>
                            <tr>
                                <th className="dataTable-title dataTable-title__w240" colSpan="2">清算の対象となる土地</th>
                                <td className="dataTable-body" colSpan="4">
                                    <ul className="l-checkBox l-checkBox--vertical">
                                        <li>
                                            <label className="checkBox">
                                                <InputCheckbox disabled id="ID_JYU01210" name="JYU01210" checked={this.props.pageState.JYU01210} {...params} />
                                                <span className="checkBox-text">1.私道負担（道路協会先後後退部分を含む）のない場合、上記土地全体</span>
                                            </label>
                                        </li>
                                        <li>
                                            <label className="checkBox">
                                                <InputCheckbox disabled id="ID_JYU01211" name="JYU01211" checked={this.props.pageState.JYU01211} {...params} />
                                                <span className="checkBox-text">2.私道負担（道路協会先後後退部分を含む）のある場合、それを除く土地部分</span>
                                            </label>
                                        </li>
                                        <li>
                                            <label className="checkBox">
                                                <InputCheckbox disabled id="ID_JYU01212" name="JYU01212" checked={this.props.pageState.JYU01212} {...params} />
                                                <span className="checkBox-text">3.{this.props.pageState.JYU01213}</span>
                                            </label>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120">清算基準<br />面積</th>
                                <td className="dataTable-body dataTable-body__w355" colSpan="2">{this.props.pageState.JYU01214}m<sup>2</sup></td>
                                <th className="dataTable-title dataTable-title__w120">清算単価</th>
                                <td className="dataTable-body dataTable-body__w355">
                                    <div className="dataTableUnit">
                                        <div className="dataTableUnit-text">1m<sup>2</sup>あたり</div>
                                        <div className="dataTableUnit-text">{this.amountCommaEdit(this.props.pageState.JYU01215)}</div>
                                        <div className="dataTableUnit-text">円</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}